// supabase-lpd.ts — de LPD-getypeerde Supabase-client (Fase 0a).
//
// De LPD-v2 tabellen ontbreken in de gegenereerde types van
// src/integrations/supabase/types.ts (dat bestand zit in de V1-hash-lock en
// mag niet geregenereerd worden). Daarom heeft de feature een eigen gen-file
// (types/database.gen.ts) en cast we het gedeelde client-object hier ÉÉN keer
// naar dat schema. Alle feature-code importeert `lpdDb` in plaats van een
// per-call any-cast op de gedeelde client — dezelfde runtime-instantie
// (auth/sessie gedeeld), alleen het type verschilt.

import type { SupabaseClient } from '@supabase/supabase-js';
import { supabase } from '@/integrations/supabase/client';
import type { Database } from '../types/database.gen';

export const lpdDb = supabase as unknown as SupabaseClient<Database>;

/**
 * Payload-cast voor insert/update/upsert. De gegenereerde Insert/Update-types
 * (jsonb-kolommen als `Json`, GENERATED-kolommen, onze eigen payload-types) zijn
 * strikter dan de runtime-payloads die functioneel correct zijn. Deze helper
 * cast één keer, expliciet en grep-baar; de type-guard voor de aanroeper blijft
 * de functie-signatuur van elke mutation (input: LaadpleinScenarioInsert, …).
 * Runtime no-op — puur compile-time.
 */
export const lpdPayload = <T>(value: T): never => value as never;
